module.exports = __webpack_public_path__ + "static/media/pfSense_step4.4fe22776.png";